import { Check } from "lucide-react";
import { Reveal, Label } from "./Motion";
import ChapterMark from "./ChapterMark";

const whoWeHelp = [
  "Have a functioning operation",
  "Generate meaningful revenue",
  "Have multiple areas of the business to manage",
  "Have data available or accessible",
  "Want to improve performance",
  "Are willing to make changes",
  "Want measurable results",
];

const strongFits = [
  "Manufacturing",
  "Home services",
  "Construction",
  "Professional services",
  "Specialty retail",
  "Healthcare practices",
  "Hospitality",
  "B2B services",
  "Established local businesses",
];

export default function IdealClient() {
  return (
    <section id="clients" data-testid="ideal-client-section" className="relative py-28 lg:py-40 bg-[#eae7de]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <ChapterMark n="03" title="Fit" className="mb-5" />
          <Label>Who we help</Label>
          <h2 className="mt-6 font-head text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-[#1e3d3a]">
            Built For Businesses<br />
            <span className="text-black/40">Ready to Improve.</span>
          </h2>
          <p className="mt-6 text-base lg:text-lg leading-relaxed text-black/65">
            Elevare works best with established businesses that have something to build on —
            and the appetite to make it better.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Who We Help */}
          <Reveal className="lg:col-span-7">
            <div className="h-full rounded-2xl border border-black/10 bg-white/70 backdrop-blur-sm p-8 lg:p-10">
              <p className="text-[10px] uppercase tracking-[0.28em] text-[#a3823f] font-medium">Elevare works best with businesses that</p>
              <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
                {whoWeHelp.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-base leading-relaxed text-[#1e3d3a]">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#1e3d3a]">
                      <Check className="h-3 w-3 text-[#eae7de]" strokeWidth={2.5} />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* Particularly Strong Fits */}
          <Reveal className="lg:col-span-5" delay={0.1}>
            <div className="h-full rounded-2xl border border-[#1e3d3a]/15 bg-[#1e3d3a] p-8 lg:p-10">
              <p className="text-[10px] uppercase tracking-[0.28em] text-[#c9a961] font-medium">Particularly strong fits</p>
              <div className="mt-8 flex flex-wrap gap-2.5">
                {strongFits.map((f) => (
                  <span
                    key={f}
                    className="rounded-full border border-white/15 bg-white/[0.06] px-4 py-2 text-sm text-white/85"
                  >
                    {f}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
